/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Icon = styled.span`
  display: inline-block;
  border: solid 1px transparent;
  line-height: 1;
`;

const SVG = styled.svg`
  height: ${(p) => p.size ? p.size : '1rem'};
  width: ${(p) => p.size ? p.size : '1rem'};
  fill: ${(p) => p.fill ? p.fill : '#54698d'};
`;

/**
 * Icon Container for Standard SLDS Icons
 */
const UtilityIcon = ({ className, onClick, icon, size, fill }) => (
  <Icon className={className} onClick={onClick} >
    <SVG size={size} fill={fill}>
      <use xlinkHref={`/assets/icons/utility-sprite/svg/symbols.svg#${icon}`}></use>
    </SVG>
  </Icon>
);

UtilityIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string
};

UtilityIcon.defaultProps = {
  show: true,
};

export default UtilityIcon;
